import { render, staticRenderFns } from "./DashboardRevenueReport.vue?vue&type=template&id=65f6f6e8&"
import script from "./DashboardRevenueReport.vue?vue&type=script&lang=js&"
export * from "./DashboardRevenueReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports